const autoNgTemplateLoaderTemplate1 = require('./customer-setup-step-2.template.html');

'use strict';

angular
    .module('app')
    .directive('customerSetupStep2', customerSetupStep2);

customerSetupStep2.$inject = [];

function customerSetupStep2() {
    return {
        restrict: 'E',
        scope: {
            createUser: '=',
            userGroup: '=',
            next: '&onNext'
        },
        templateUrl: autoNgTemplateLoaderTemplate1,
        controller: 'CustomerSetupStep2Controller',
        controllerAs: 'vm'
    };
}
